import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';

const EledoAuthCallback = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get('token');
    const state = params.get('state');
    // completeSsoLogin(code!, state!)
    //   .then(() => navigate('/login/success'))
    //   .catch(() => navigate('/login/error'));
  }, []);

  return (
    <div>Completing login...</div>
  )
}

export default EledoAuthCallback